import { Box } from '../Box/Box'
import {
  LinearProgress as MuiLinearProgress,
  LinearProgressProps as MuiLinearProgressProps
} from '@mui/material'
import { Typography } from '../Typography/Typography'
import React from 'react'

export type LinearProgressProps = Pick<
  MuiLinearProgressProps,
  'value' | 'valueBuffer' | 'color'
> & {
  showPercentage?: boolean
}
export const LinearProgress: React.FC<LinearProgressProps> = ({
  value,
  showPercentage = false,
  valueBuffer,
  color
}) => {
  // Check if the value is defined and convert it to a number, otherwise default to 0.
  // Ensure the value is never greater than 100.
  const normalizedValue = typeof value === 'number' ? Math.min(100, Math.max(0, value)) : 0

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <MuiLinearProgress
          variant={valueBuffer ? 'buffer' : 'determinate'}
          value={normalizedValue}
          valueBuffer={valueBuffer}
          color={color}
        />
      </Box>
      {showPercentage && (
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="bodySmall" color="text.secondary">{`${Math.round(
            normalizedValue
          )}%`}</Typography>
        </Box>
      )}
    </Box>
  )
}
